// selectedInfoSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const selectedInfoSlice = createSlice({
  name: 'selectedInfo',
  initialState: {
    value: 'Rankings',
  },
  reducers: {
    setSelectedInfo: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setSelectedInfo } = selectedInfoSlice.actions;
export default selectedInfoSlice.reducer;
